<template ref="create-business">
  <Modal
    width="900"
    v-model="show"
    :mask-closable="false"
    :loading="loading"
  >
    <div slot="header" class="modal-header">新建商机</div>
    <Form :model="formData" :label-width="100" :rules="formRules" ref="formData" v-if="enumList">
      <FormItem label="项目" prop="projectFid" class="">
        <Select v-model="formData.projectFid" class="item-width" @on-change="changeProject" :disabled="isHouseRemind">
          <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
      </FormItem>
      <FormItem label="电话" prop="customerPhone" class="">
        <Input v-model="formData.customerPhone" class="item-width"></Input>
      </FormItem>
      <Row>
        <Col span="12">
          <FormItem label="姓名" prop="customerName">
            <Input v-model="formData.customerName" class="item-width"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="" :label-width="22" prop="customerGender">
            <RadioGroup v-model="formData.customerGender">
              <Radio :label="2">
                <span>男</span>
              </Radio>
              <Radio :label="1">
                <span>女</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="来源渠道" prop="businessFromChannel">
            <Select v-model="formData.businessFromChannel" class="item-width" @on-change="formData.businessChannelInfo=''">
              <Option value="">请选择</Option>
              <Option v-for="item in channelList" :value="item.value" :key="item.value" v-show="item.show">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>

        <Col span="12">
          <FormItem label="渠道人信息"  v-if="[5, 8, 12, 6].indexOf(formData.businessFromChannel)!==-1">
            <Input v-model="formData.businessChannelInfo" placeholder="请填写姓名和系统号"  class="item-width"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="期望入住时间" prop="intentionInTime">
            <DatePicker style="width:250px" v-model="formData.intentionInTime" :options="dateOption"  split-panels  format="yyyy-MM-dd" placeholder="期望入住时间"></DatePicker>
          </FormItem>

        </Col>
        <Col span="12">
          <FormItem label="预算范围" prop="budgetRange">
            <Select v-model="formData.budgetRange" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in budgetRangeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            元/月
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="几人居住" prop="checkinNum">
            <Select v-model="formData.checkinNum" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in liveNumberList" :value="item" :key="item">{{item}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="带看意向房型" prop="houseTypeFid">
            <Select v-model="formData.houseTypeFid" class="item-width">
              <Option value="">请选择</Option>
              <Option v-for="item in houseTypeFidList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="12">
          <FormItem label="找房意向户型" prop="houseType">
            <Select v-model="formData.houseType" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="20">
        <Col span="12">
          <FormItem label="意向面积" prop="intentionArea">
            <Select v-model="formData.intentionArea" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in intentionAreaList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            <!-- <Input v-model="formData.customerCompany" class="item-width"></Input> -->
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="工作地点" prop="workAddressArr">
<!--            <Cascader :data="placeList" trigger="hover" v-model="workAddressArr" class="item-width"></Cascader>-->
         <location ref="workaddress" :id="'workaddress'"></location>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem class="zIndex" style="margin-bottom:0;float:left;margin-right:10px;z-index:99" label="期望租住时长" prop="rentPeriod">
            <Select v-model="formData.rentPeriod" @on-change="changeRentPeriod"
                    style="width: 182px;display: inline-block;z-index:99">
              <Option :value=0>请选择</Option>
              <Option :value=1>长租</Option>
              <Option :value=2>短租</Option>
            </Select>
          </FormItem>
          <FormItem label="" prop="rentNumber">
            <InputNumber v-if="formData.rentPeriod"  v-model="formData.rentNumber" :max="25" :min="0" style="width: 50px;"></InputNumber>
            <span v-if="formData.rentPeriod && formData.rentPeriod==1">年</span>
            <span v-if="formData.rentPeriod &&formData.rentPeriod==2">月</span>
          </FormItem>
        </Col>
        <Col span="12" v-if=" formData.rentPeriod &&formData.rentPeriod==2">
          <FormItem  label="短租用途" prop="clientType" >
            <Select v-model="formData.clientType"  class="item-width">
              <Option value="">请选择</Option>
              <Option v-for="item in shortRentDesList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>

        <Col span="12">
          <FormItem label="通勤方式" prop="commutingMode">
            <Select v-model="formData.commutingMode"  class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in commutingModeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="现住地点" >
<!--            <Cascader :data="placeList" trigger="hover" v-model="residenceArr" class="item-width"></Cascader>-->
            <location ref="residenceaddress" :id="'residenceaddress'"></location>

          </FormItem>
        </Col>
      </Row>
      <Row>

        <Col span="12">
          <FormItem label="期望通勤时长" prop="">
            <Select  v-model="formData.commutingDuration"  class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.commutingDuration" :value="item.value" :key="item.value+'keyB'">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="工作状态" prop="" >
            <Select v-model="formData.currentStatus"  class="item-width">
              <Option :value=0>请选择</Option>
                            <Option v-for="item in enumList.currentStatus" :value="item.value" :key="item.value+'keyC'">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
<!--      <Row>-->
<!--          <Col span="12">-->
<!--            <FormItem label="商机等级" prop="grade">-->
<!--              <Select v-model="formData.grade"  class="item-width">-->
<!--                <Option v-for="item in gradeList" :value="item.text" :label="item.text" :key="item.text+'keyD'">-->
<!--                  <span>{{item.text}}</span>-->
<!--                  <span style="margin-left: 10px;color:#80848f">{{item.value}}</span>-->
<!--                </Option>-->
<!--              </Select>-->
<!--            </FormItem>-->
<!--          </Col>-->
<!--      </Row>-->
      <Row>
        <Col span="12">
          <FormItem label="处理结果" prop="result">
            <Cascader trigger="hover" :data="statusList" v-model="formData.result" @on-change="changeResult"
                      class="item-width"></Cascader>
          </FormItem>
        </Col>
        <Col span="12" style="padding-left: 15px">
          <FormItem class="ivu-form-item-required" label="是否带看" prop="isLook" v-if="showLookRadio">
            <RadioGroup v-model="formData.isLook">
              <Radio :label="0">
                <span>否</span>
              </Radio>
              <Radio :label="1">
                <span>是</span>
              </Radio>
            </RadioGroup>
            <div v-show="isLookError" class="error-tip">请选择是否带看</div>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem class="ivu-form-item-required" label="合同手机号" prop="contractPhone" v-if="showContract">
            <Input v-model="formData.contractPhone">
              <Button slot="append" icon="ios-search" @click="readContract"></Button>
            </Input>
            <div v-show="contractError" class="error-tip">请查询有效合同号</div>
          </FormItem>
        </Col>
        <Col span="4">
          <div  v-if="showContract" class="contract-code-box">{{formData.contractCode}}</div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="handleRecordLabel" prop="handleRecord">
            <Input type="textarea" :autosize="{minRows: 2}" :placeholder='handleRecordPlaceholder'
                   v-model="formData.handleRecord"></Input>
          </FormItem>
        </Col>
      </Row>
      <FormItem ref="appointVisit" class="ivu-form-item-required" label="带看时间" prop="appointVisitTime"
                v-if="showAvDataPicker">
        <DatePicker placement="top" :options="dateOption" ref="appointVisitTime" type="datetime"
                    format="yyyy-MM-dd HH:mm" v-model="formData.appointVisitTime"
                    @on-change="formData.appointVisitTime=$event" placeholder="yyyy-mm-dd HH:mm"
                    class="item-width"></DatePicker>
        <div v-show="avError" class="error-tip">请选择带看时间</div>
      </FormItem>
      <FormItem class="ivu-form-item-required" :label="lable" prop="returnVisitTime" v-if="showRvDataPicker">
        <DatePicker placement="top" :options="dateOption" ref="returnVisitTime" type="datetime"
                    format="yyyy-MM-dd HH:mm" v-model="formData.returnVisitTime"
                    @on-change="formData.returnVisitTime=$event" placeholder="yyyy-mm-dd HH:mm"
                    class="item-width"></DatePicker>
        <div v-show="rvError" class="error-tip">请选择{{lable}}</div>
      </FormItem>
    </Form>
    <cancel-modal :n="cancelKey" @cancel="close"></cancel-modal>
    <div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loading">
        <span v-if="!loading">保存</span>
        <span v-else>保存中...</span>
      </Button>
    </div>

  </Modal>
</template>
<script type="text/ecmascript-6">
  import {getProjectHouseType} from 'api/common'
  import {createBusiness, getContractCode,getRegionByProjectFid,getAreaRegionByProjectFid} from "api/business";
  import CancelModal from 'components/CancelModal/index';
  import {deepClone, formatDateTimeExceptSecond, formatDateTime} from '@/utils/format';
  import Location from 'components/Location/index'

  export default {
    props: {
      n: {
        type: Number,
        default: 0
      },
      projectFid: {
        type: String,
        default: ''
      },
      statusList: {
        type: Array,
        default(){
          return []
        }
      },
      channelList: {
        type: Array,
        default(){
          return []
        }
      },
      projectList: {
        type: Array,
        default(){
          return []
        }
      },
      clientTypeList: {
        type: Array,
        default(){
          return []
        }
      },
      budgetRangeList:{
        type: Array,
        default(){
          return []
        }
      },
      commutingModeList:{
        type: Array,
        default(){
          return []
        }
      },
      intentionAreaList:{
        type: Array,
        default(){
          return []
        }
      },
      houseTypeList:{
        type: Array,
        default(){
          return []
        }
      },
      liveNumberList:{
        type: Array,
        default(){
          return []
        }
      },
      // placeList:{
      //   type: Array,
      //   default: []
      // },
      shortRentDesList:{
        type: Array,
        default(){
          return []
        }
      },
      rentTimeList:{
        type: Array,
        default(){
          return []
        }
      },
      customerPhone: {
        type: String,
        default: ''
      },
      customerName: {
        type: String,
        default: ''
      },
      isHouseRemind: {
        type:Boolean,
        default:false
      },
      houseTypeFid: {
        type: String,
        default: ''
      },
      houseRemindFid: {
        type: String,
        default: ''
      },
      enumList:{
        type:Object,
        defalut:null
      },
      gradeList:{
        type: Array,
        default(){
          return []
        }
      }
    },
    components: {
      CancelModal,
      Location
    },
    mounted(){


    },
    data() {
      const validatecontactPhone = (rule, value, callback) => {
        const pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的联系方式'));
        }
        callback();
      };
      const validateRentNumber = (rule, value, callback) => {
        if(this.formData.rentPeriod){
            if(!value){
              callback(new Error('请输入期望租住时长'));
            } else{
              callback();
            }
        }
          callback();
        }
        return {
        dateOption: {
          disabledDate (date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
        houseTypeFidList:[],
        placeList:[],
        cancelKey: 0,
        show: false,
        loading: false,
        lable: '跟进时间',
        handleRecordLabel: '跟进记录',
        handleRecordPlaceholder: '租住人数、特殊需求记录，最多输入150字',
        showAvDataPicker: false,
        showLookRadio: false,
        showContract: false,
        showRvDataPicker: false,
        avError: false,
        rvError: false,
        isLookError: false,
        contractError: false,
        disabled: false,
        result: '',
        workAddressArr:[],
        residenceArr:[],
        formData: {
          commutingDuration:'',
          currentStatus:'',
          appointVisitTime: '', // 约看时间
          budgetPriceRange: '',
          businessFid: '',
          businessFromChannel: '',
          businessMessage: '',
          contractCode: '',
          contractPhone: '',
          customerCompany: '',
          customerFid: '',
          customerGender: '',
          customerName: '',
          customerPhone: '',
          expectCheckinTime: '',
          expectVisitTime: '',
          handleRecord: '',
          handleResult: '',
          handleStatus: '',
          clientType: '',
          houseTypeFid: '',
          isLook: '',
          projectFid: '',
          returnVisitTime: '',
          zoFid: '',
          zoName: '',
          result: [],
          rentPeriod: '',
          rentNumber: null,
          handleDetailMsg: '',
          businessChannelInfo:'',
          intentionInTime:'',
          budgetRange:'',
          checkinNum:'',
          intentionArea:'',
          commutingMode:'',
          houseType:'',
          houseRemindFid:'',//有房提醒转商机
          grade: ''
        },
        formRules: {
          projectFid: [{required: true, message: '请选择项目', trigger: 'change', type: 'string'}],
          customerName: [{required: true, message: '请输入客户姓名', trigger: 'blur', type: 'string'}],
          customerPhone: [{required: true, validator: validatecontactPhone, trigger: 'blur'}],
          // houseTypeFid:[ {required:true, message: '请输选择意向房型', trigger: 'change', type: 'string'}],
          businessFromChannel: [{required: true, message: '请输选择来源渠道', trigger: 'change', type: 'number'}],
          result: [{required: true, message: '请选择处理结果', trigger: 'change', type: 'array'}],
          rentNumber:[{ required: true,validator: validateRentNumber,trigger: 'change'}],
          // houseTypeId:[{ required: true, message: '请选择意向房型' ,trigger: 'change', type:'string'}],
          handleDetailMsg:[ {required:true, message: '请填写更详细的丢单原因', trigger: 'blur', type:'string'}],
          handleRecord:[ {required:true, message: '请填写备注或跟进记录', trigger: 'blur', type:'string'},{validator: this.handleRecordIsLength, trigger: 'blur'}],
          // grade:[ {required:true, message: '请选择商机等级', trigger: 'change', type:'string'}]
        },
        dateOption: {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        },
      };
    },
    watch: {
      n(val) {
        this.$refs['formData'] && this.$refs['formData'].resetFields();
        this.formData.projectFid = this.projectFid ? this.projectFid : this.projectList[0].value
        // this.workAddressArr = [];
        // this.residenceArr = [];
        this.showAvDataPicker = false
        this.showRvDataPicker = false
        this.showContract = false
        this.disabled = false
        this.loading = false
        this.showLookRadio = false
        this.show = true;
        // 有房提醒
        if(this.isHouseRemind){
          this.formData.customerPhone = this.customerPhone
          this.formData.customerName = this.customerName
          this.formData.houseTypeFid = this.houseTypeFid
          this.formData.businessFromChannel = 13
          this.formData.houseRemindFid = this.houseRemindFid
        }

        this.$refs['workaddress'] &&  this.$refs['workaddress'].resetData()
        this.$refs['residenceaddress']&&  this.$refs['residenceaddress'].resetData()

      },
      statusList: {
        deep: true,
        handler(val) {
          this.toCascaderData(val)
        }
      },
      workAddressArr(val){
        if(val.length>0){
          if(val[0]){
            this.formData.workAddressArea = val[0]
          }
          if(val[1]){
            this.formData.workAddress = val[1]
          }
        } else{
          this.formData.workAddressArea = '';
          this.formData.workAddress = ''
        }
      },
      residenceArr(val){
        if(val.length>0){
          if(val[0]){
            this.formData.residenceArea = val[0]
          }
          if(val[1]){
            this.formData.residence = val[1]
          }
        } else{
          this.formData.residenceArea = '';
          this.formData.residence = ''
        }
      },
      "formData.customerPhone":{
        handler(val){
          this.formData.contractPhone = val
        }
      }
    },
    methods: {
      getRegion(val){
        getAreaRegionByProjectFid({
          projectFid:val
        })
        .then(res => {
          this.placeList = res.data;
        })
      },
      changeProject(val) {
        getProjectHouseType(val).then(res => {
          this.houseTypeFidList = res.data
        })
        this.workAddressArr = []
        this.residenceArr = []
        this.getRegion(val);
      },
      changeResult(value, selectedData) {
        this.resetHideData()
        this.result = selectedData.length === 1 ? '' : selectedData[1].text
        const firstResult = value[0]
        this.lable = firstResult == 1 ? '跟进时间' : '回访时间'
        this.showContract = (firstResult == 4 || firstResult == 7) ? true : false
        this.showLookRadio = firstResult == 5 ? true : false
        this.showAvDataPicker = firstResult == 2 ? true : false
        this.showRvDataPicker = firstResult == 1 || firstResult == 3 ? true : false
        if (firstResult == 4) {
          this.handleRecordLabel = '签约备注';
          this.handleRecordPlaceholder ='商机成交的房源/公寓原因、客户原因记录，最多输入150个字';
        } else if (firstResult == 5) {
          this.handleRecordLabel = '丢单备注';
          this.handleRecordPlaceholder ='商机未成交的房源/公寓原因、客户原因记录，最多输入150个字';
        } else {
          this.handleRecordLabel = '跟进记录';
          this.handleRecordPlaceholder ='租住人数、特殊需求记录，最多输入150字';
        }
      },
      getResultStr(code) {
        let str = ''
        let detailmsg = ''
        switch (code) {
          case '1' :
            str = `跟进时间:${this.formData.returnVisitTime}`
            break;
          case '2':
            str = `带看时间:${this.formData.appointVisitTime}`
            break;
          case '3':
            str = `回访时间:${this.formData.returnVisitTime}`
            break;
          case '4':
            str = `合同号:${this.formData.contractCode}`
            break;
          case '5':
            str = this.formData.isLook === 0 ? '未带看' : '已带看'
            detailmsg = `${this.formData.handleDetailMsg}`
            break;
        }

        if (detailmsg) {
          detailmsg = '/' + detailmsg
        }

        return this.result == '' ? detailmsg + str : this.result + detailmsg + '-' + str
      },
      resetHideData() {
        this.formData.appointVisitTime = ''
        this.formData.returnVisitTime = ''
        this.formData.contractCode = ''
        this.formData.isLook = ''
        this.formData.handleDetailMsg = ''
        this.avError = false
        this.rvError = false
        this.isLookError = false
        this.contractError = false
        this.disabled = false
      },
      validateHideData() {
        if (this.formData.result.length < 1) return true
        const status = this.formData.result[0]
        this.avError = status == 2 && this.formData.appointVisitTime === '' ? true : false
        this.rvError = (status == 1 || status == 3) && this.formData.returnVisitTime === '' ? true : false
        this.isLookError = status == 5 && this.formData.isLook === '' ? true : false
        this.contractError = status == 4 && this.formData.contractCode === '' ? true : false
        return !(this.avError || this.rvError || this.isLookError || this.contractError)
      },
      toCascaderData(array) {
        array.forEach(item => {
          if (item.children) {
            item.children.forEach(child => {
              if (!child) return
              this.addKey(child, 'label', 'text')

            })
          }
          this.addKey(item, 'label', 'text')
        })
      },
      addKey(o, new_key, old_key) {
        Object.defineProperty(o, new_key,
          Object.getOwnPropertyDescriptor(o, old_key));
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      readContract() {
        if (!this.formData.contractPhone) {
          this.formData.contractPhone = this.formData.customerPhone
        }
        if ((/^1\d{10}$/.test(this.formData.contractPhone))) {
          getContractCode({
            phone: this.formData.contractPhone,
            projectFid: this.formData.projectFid,
            status: this.formData.result[0]
          }).then(res => {
            if (res.data) {
              this.formData.contractCode = res.data
              this.disabled = true
            } else {
              this.formData.contractCode = null
              this.$Message.info('未查询到有效的合同号！')
            }
          })
        } else {
          this.$Message.error('请输入有效的手机号')
        }
      },
      handleCancel() {
        this.cancelKey++

      },
      close() {
        this.show = false
      },
      save() {
        const data = {}
        //格式化日期
        if (typeof this.formData.appointVisitTime == 'object' && this.formData.appointVisitTime !== null) {
          this.formData.appointVisitTime = formatDateTime(this.formData.appointVisitTime)
        }
        if (typeof this.formData.returnVisitTime == 'object' && this.formData.returnVisitTime !== null) {
          this.formData.returnVisitTime = formatDateTime(this.formData.returnVisitTime)
        }
        if (typeof this.formData.intentionInTime == 'object' && this.formData.intentionInTime !== null) {
          this.formData.intentionInTime = formatDateTime(this.formData.intentionInTime)
        }
        this.$refs["formData"].validate(bool => {
          if (bool && this.validateHideData()) {
            if (this.showContract && !this.formData.contractCode) {
              this.$Message.error("请根据手机号查询有效的合同")
              return
            }
            for (const key in this.formData) {
              if (key === 'result') {
                continue;
              } else if (key === 'handleStatus') {
                data[key] = this.formData.result[0]
              } else if (key === 'handleResult') {
                data[key] = this.getResultStr(this.formData.result[0])
              } else {
                data[key] = this.formData[key]
              }
            }

            //地点调整
            const workdata=this.$refs['workaddress'].data
            data['workAddressCity']=workdata.cityCode
            data['workAddressArea']=workdata.regionCode
            data['workAddressDesc']=workdata.address
            data['workAddressLon']= workdata.lng
            data['workAddressLat']= workdata.lat

            const  residenceaddress=this.$refs['residenceaddress'].data
            data['residenceCity']=residenceaddress.cityCode
            data['residenceArea']=residenceaddress.regionCode
            data['residenceDesc']=residenceaddress.address
            data['residenceLon']= residenceaddress.lng
            data['residenceLat']= residenceaddress.lat


            data['workAddress']=''
            data['residence']=''

            createBusiness(data).then(res => {
              this.$Message.success('创建成功');
              this.changeLoading()
              this.$emit('refresh')
              this.show = false
            }).catch(() => {
              this.changeLoading()
              this.show = false
            })
          } else {

            // this.changeLoading()
            return
          }
        });
      },
      changeRentPeriod(value) {
        if (value != 0) {
          this.formData.rentNumber = null
        } else {
          this.formData.rentNumber = null
        }
      },
      handleRecordIsLength(rule, value, callback) {
        if(value.split(" ").join("").length === 0){
          callback(new Error('备注或者跟进记录不能全为空格'));
        }
        value = value.replace(/\s*/g,"")
        const enc = new TextEncoder("utf-8");
        if(value==''||value==undefined||value==null) {
          callback();
        }else if (enc.encode(value).length<12) {
          callback(new Error('备注或者跟进记录除空格外，汉字不能少于4，字符不能少于12'));
        } else if (value.length>150) {
          callback(new Error('备注或者跟进记录字数不能超过150'));
        } else {
          callback();
        }
      },
    }
  }
</script>
<style scoped>
  .item-width {
    width: 250px;
  }

  .area-width {
    width: 450px;
  }


  .error-tip {
    position: absolute;
    color: #F56356;
  }

  .contract-code-box {
    padding-left: 16px;
    line-height: 32px;
    font-weight: bolder;
  }

</style>
<style>
  .zIndex .ivu-form-item-content{
    z-index: 99;
  }
</style>

